import request from '@/utils/request'

export function getDeptPerformanceCorrelationOverview () {
  return request({
    url: '/addon/deptPerformanceCorrelation/overview',
    method: 'get'
  })
}
